import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { IndexComponent } from './index/index.component';
import { ClassifiedTopVideosComponent } from './components/classified-top-videos/classified-top-videos.component';
import { RecommendedNewsComponent } from './components/recommended-news/recommended-news.component';
import { AppRoutingModule } from './app-routing.module';
import { CommentService } from './_service/comment/comment.service';
import { ApiUrlHelper } from './_service/api-url-helper';
import { ResourceService } from './_service/resource/resource.service';
import { SubindexComponent } from './subindex/subindex.component';
import { RechargeBoxService } from './_service/recharge-box/recharge-box.service';
import { VotingService } from './_service/voting/voting.service';
import { MenuService } from './_service/menu/menu.service';
import { UserService } from './_service/user/user.service';
import { VideoListService } from './_service/video/video-list.service';
import { SearchService } from './_service/search/search.service';
import { SearchHistoryService } from './_service/search/search-history.service';
import { PlayHistoryService } from './_service/history/play-history.service';
import { CookieService } from 'ngx-cookie-service';
import { FavoriteService } from './_service/favorite/favorite.service';
import { MessageService } from './_service/message/message.service';
import { AuthGuard } from './_guards/auth.guard';
import { NavPanelComponent } from './components/nav-panel/nav-panel.component';
import { SharedModule } from './components/shared.module';
import { DnDialogModule } from './_modules/dn-dialog/dn-dialog.module';
import { DnDialogService } from './_modules/dn-dialog/dn-dialog.service';
import { VideoTransFormer } from './_transformers/video.transformer';
import { MediaTransFormer } from './_transformers/media.transformer';
import { UserTransFormer } from './_transformers/user.transformer';
// import { MessageDialogService } from './components/dialogs/message-dialog/message-dialog.service';
import { NotificationService } from './_service/notification/notification.service';
import { ConfirmDialogService } from './components/dialogs/confirm-dialog/confirm-dialog.service';
import { PurchaseRequiredDialogService } from './components/dialogs/purchase-required/purchase-required.service';
import { PipesModule } from './_pipes/pipes.module';
import { GgService } from './_service/gg/gg.service';
import { appStoreProviders } from './app.store';
import { CategoryService } from './_service/category/category.service';
import { MessageTransFormer } from './_transformers/message.transformer';
import { NotificationTransFormer } from './_transformers/notification.transformer';
import { RechargeRecordformer } from './_transformers/recharge-record.transformer';
import { WindowService } from './_service/screen-size.service';
import { CommentListService } from './_service/comment/comment-list.service';
import { CommentTransFormer } from './_transformers/comment.transformer';
import { RegionService } from './_service/region/region.service';
import { ConfigService } from './_service/config/config.service';
import { NavbarLinksService } from './_service/navbar/navbar.service';
import { ToastrModule } from 'ngx-toastr';
import { BlackToastComponent } from './components/black-toast/black-toast.component';
import { WebformService } from './_service/webform/webform.service';
import { PaymentService } from './_service/payment/payment.service';
import { ToastService } from './_service/toast/toast.service';
import { SliderTransformer } from './_transformers/slider.transformer';
import { LoginBoxComponent } from './login-box/login-box.component';
import { NewsTransFormer } from './_transformers/news.transformer';
import { HttpClientHelper } from './_service/http-helper';
import { RandomVideosService } from './_service/video/random-videos.services';
import { ClassifiedTopVideosService } from './_service/video/classified-top-videos.services';
import { RankedVideosService } from './_service/video/ranked-videos.services';
import { PurchaseSuccessDialogService } from './components/dialogs/purchase-success/purchase-success.service';
import { StorageService } from './storageprovider';
import { PermissionService } from './PermissionService';
import { SeoService } from './seoservice/seoservice';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { NotifyService } from './_service/notify/notifyService';
import { ReleaseScheduleComponent } from './release-schedule/release-schedule.component';
import { DnFocusesService } from './_service/dn-focus/dn-focus.service';
import { ClassifiedTopVideosNewsComponent } from './components/classified-top-videos/classified-top-videos-news/classified-top-videos-news.component';
import { DnSliderModule } from './_model/dn-slider/dn-slider.module';
import { SocketModule } from './_modules/socket/socket.module';
import { FullScreenService } from './_service/full-screen/full-screen.service';
import { ChallengeComponent } from './challenge/challenge.component';
import { LazyDirective } from './_directive/lazy.directive';
import { DiscoveryInHomeModule } from './_modules/discovery-in-home/discovery-in-home.module';
import { StickyChatModule } from './_modules/sticky-chat/sticky-chat.module';
import { SharedTopnavComponent } from './shared-topnav/shared-topnav.component';
import { NewSvideoContainerModule } from './components/new-svideo-container/new-svideo-container.module';
import { TestsComponent } from './tests/tests.component';
import { DialogModule } from './_modules/dialog/dialog.module';
import { TvLiveModule } from './tv-live/tv-live.module';


@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    ClassifiedTopVideosComponent,
    ClassifiedTopVideosNewsComponent,
    RecommendedNewsComponent,
    SubindexComponent,
    NavPanelComponent,
    BlackToastComponent,
    LoginBoxComponent,
    ReleaseScheduleComponent,
    ChallengeComponent,
    LazyDirective,
    SharedTopnavComponent,
    TestsComponent,
  
   // LoginComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    BrowserAnimationsModule,
    DnSliderModule,
    PipesModule,
    DnDialogModule,
    ToastrModule.forRoot({
      toastComponent: BlackToastComponent,
      positionClass: 'toast-screen-center',
      timeOut: 2000,
      preventDuplicates: true,
    }),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      }
    }),
    SocketModule,
    StickyChatModule,
    DiscoveryInHomeModule,
    NewSvideoContainerModule,
    DnSliderModule,
    DialogModule,
    TvLiveModule,
  ],
  providers: [
    MenuService,
    UserService,
    SearchService,
    VideoListService,
    CookieService,
    FavoriteService,
    PlayHistoryService,
    MessageService,
    ResourceService,
    //SubscribeService,
    AuthGuard,
    RechargeBoxService,
    ApiUrlHelper,
    CommentService,
    CommentListService,
    CommentTransFormer,
    VotingService,
    VideoTransFormer,
    MediaTransFormer,
    UserTransFormer,
    SliderTransformer,
    NewsTransFormer,
    GgService,
    // MessageDialogService,
    ConfirmDialogService,
    appStoreProviders,
    CategoryService,
    MessageTransFormer,
    NotificationTransFormer,
  //  LiveTransFormer,
    WindowService,
    RechargeRecordformer,
    DnDialogService,
    RegionService,
    ConfigService,
    NavbarLinksService,
    WebformService,
    PaymentService,
    PurchaseRequiredDialogService,
    PurchaseSuccessDialogService,
    ToastService,
    NotificationService,
    HttpClientHelper,
    RandomVideosService,
    ClassifiedTopVideosService,
    RankedVideosService,
    StorageService,
    PermissionService,
    SeoService,
    NotifyService,
    FullScreenService,
    DnFocusesService,
    SearchHistoryService,
  ],
  exports: [
    BlackToastComponent
  ],
  // entryComponents: [
  //   BlackToastComponent
  // ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {

  }
}
